import Intercom, { show } from "@intercom/messenger-js-sdk";

import { INTERCOM_APP_ID } from "@/common/utils/env";

export function initIntercom(jwt: string) {
  if (!INTERCOM_APP_ID) {
    return;
  }
  Intercom({
    app_id: INTERCOM_APP_ID,
    hide_default_launcher: true,
    intercom_user_jwt: jwt,
  });
}

export function openIntercom() {
  show();
}
